import { memo, useEffect, useState } from "react"
import { Form } from "react-bootstrap"
import PlaceService, { IPlace } from "../services/PlaceService"
import Utils from "../utils/Utils"

interface IPlaceSelectProps {
    providerId: number | null
    placeId: number | null
    required?: boolean
    onChange: (e: any) => void
}

function PlaceSelect(props: IPlaceSelectProps) {
    const [placeOptions, setPlaceOptions] = useState([] as any[])

    const PlaceOptions = async (providerId: number) => {
        const res = await PlaceService.listAllPublished(providerId)
        let options: any[] = []

        if (res?.isSuccess) {
            options = res.data.map((item: IPlace) => <option key={item.id} value={item.id || 0}>{item.name}</option>)
        } else {
            console.log(res?.message)
        }

        return options
    }

    useEffect(() => {
        if (props.providerId) {
            PlaceOptions(props.providerId).then(options => {
                setPlaceOptions(options)
            })
        }
    }, [])

    return <>
        <Form.Group className="mb-3" controlId="placeId">
            <Form.Label>Place</Form.Label>
            <Form.Select name="placeId" required={props.required} value={props.placeId || ""} onChange={props.onChange}>
                <option value=""></option>
                {placeOptions}
            </Form.Select>
            {props.required && <Form.Control.Feedback type="invalid">Select a place.</Form.Control.Feedback>}
        </Form.Group>
    </>
}

export default memo(PlaceSelect)